import {
    gerenciaTecnicaSlice,
    LocationSlice,
    mainSlice,
    planningSlice,
} from "./slices";

export const reducer = {
    main: mainSlice.reducer,
    gerenciaTecnica: gerenciaTecnicaSlice.reducer,
    location: LocationSlice.reducer,
    planning: planningSlice.reducer,
};
